import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=564d1070&scoped=true"
import script from "./AddProducts.vue?vue&type=script&lang=js"
export * from "./AddProducts.vue?vue&type=script&lang=js"
import style0 from "./AddProducts.vue?vue&type=style&index=0&id=564d1070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d1070",
  null
  
)

export default component.exports